module.exports = __webpack_public_path__ + "img/MiniwebFrontElegant.96be9a6e.png";